import {GAP} from 'biojs/BioConstants';

/**
 * Return a mapping of gapped amino acid indices to "real"/non-gapped indices,
 * e.g. 'AAR-D--VARK' would return [0, 1, 2, 4, 7, 8, 9, 10]
 */
export function getRealToGapMap(aminoAcids: string): Array<number> {
  const acids = aminoAcids.split('');

  if (!aminoAcids.includes(GAP)) {
    return acids.map((acid, index) => index);
  }

  const realToGapMap = [];
  for (let i = 0; i < aminoAcids.length; i++) {
    if (acids[i] !== GAP) {
      realToGapMap.push(i);
    }
  }
  realToGapMap.push(realToGapMap[realToGapMap.length - 1] + 1); // adjust for exclusive endpoint
  return realToGapMap;
}
